import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { HrLearningAssignment } from '../../../hr/hr.models';
import { MyHrWorkspaceService } from '../shared/my-hr-workspace.service';
import { labelize, statusSeverity } from '../shared/my-hr-workspace.utils';

@Component({
  selector: 'app-my-hr-learning',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
  templateUrl: './my-hr-learning.component.html',
  styleUrls: ['./my-hr-learning.component.scss']
})
export class MyHrLearningComponent implements OnInit {
  private readonly workspaceService = inject(MyHrWorkspaceService);

  assignments: HrLearningAssignment[] = [];

  ngOnInit(): void {
    this.workspaceService.loadLearning().subscribe({
      next: assignments => {
        this.assignments = assignments;
      },
      error: () => {
        this.assignments = [];
      }
    });
  }

  label(value?: string): string {
    return labelize(value);
  }

  statusSeverity(value?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' {
    return statusSeverity(value);
  }
}
